import 'react-native-gesture-handler';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';

import Splash from './screens/Splash';
import Tabs from './screens/Tabs.js';
import Player from './screens/Player.js';
import Buy from './screens/Buy.js';

import { navigationRef } from './RootNavigation';

import React, { Component } from 'react'
import { Stylesheet,
         Text,
         View,
         Image,
         TouchableWithoutFeedback,
         StatusBar,
         TextInput,
         SafeAreaView,
         Keyboard,
         TouchableOpacity,
         KeyboardAvoidingView } from 'react-native';
import List from './screens/List';
import Payment from './screens/Payment';
const Stack = createStackNavigator();

export default function MyStack() {
  
  return (

    <NavigationContainer ref={navigationRef}>
      <Stack.Navigator
       initialRouteName="Splash"
      screenOptions={{
    headerShown: false,
        gestureEnabled: true,
    headerMode: 'none',
  }}
      >
         <Stack.Screen
          name="Tabs"
          component={Tabs}
          options={{ headerShown: false }}
        />
      <Stack.Screen
        name="Splash"
        component={Splash}

      />
      <Stack.Screen
        name="Player"
        component={Player}

      />
       <Stack.Screen
        name="Buy"
        component={Buy}

      />
      <Stack.Screen
        name="Payment"
        component={Payment}

      />
      <Stack.Screen
        name="List"
        component={List}

      />
  
     
     
   
     </Stack.Navigator>

    </NavigationContainer>
    
  );
}